export interface Logger 
{
    debug(msg: any): void;
    log(msg: any): void;
    warn(msg: any) : void;
    error(msg: any): void;
}

class DebugLoggerImpl implements Logger
{
    constructor(private className: any)
    {

    }
    debug(msg: any) { console.debug(this.className + ":->", msg); }
    log(msg: any)   { console.log(this.className + ":-> " + msg); }
    error(msg: any) { console.error(this.className + ":-> " + msg); }
    warn(msg: any)  { console.warn(this.className+ ":-> " + msg); }
}


class ReleaseLoggerImpl  implements Logger
{
    constructor()
    {

    }

    debug(msg: any) {  }
    log(msg: any)   {  }
    error(msg: any) { }
    warn(msg: any)  {  }
}


export class LogManager
{
    private static isEnabled: boolean = true;

    static setEnabled(isEnabled: boolean)
    {
        this.isEnabled = isEnabled;
    }
  
    static getLogger(className: string): Logger
    {
        return LogManager.isEnabled ? new DebugLoggerImpl(className) : new ReleaseLoggerImpl();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/logger/logger.tsx